module.exports = __webpack_public_path__ + "static/media/slika.f3b65c5b.png";